const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    modules: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveGuid: null,
});

export default {
    getInitialState
};
